import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getNewsPage } from "@/_pages/news/api";
import type { NewsListType } from "@/_pages/news/model";
import type { NewsPageType } from "@/_pages/news/model/types";
import { NewsPage } from "@/_pages/news/ui";

type PageProps = {
  cms: {
    list: NewsListType;
    page: NewsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { list, page },
  } = props;

  return <NewsPage content={list} page={page} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getNewsPage()),
      };
    },
    { res },
  );
}

export default Page;
